"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadWistiaApi = loadWistiaApi;
exports.loadVidyardApi = loadVidyardApi;

function loadScript(url, onLoad, onError) {
  var scriptElement = document.createElement('script');

  if (onError) {
    scriptElement.onerror = onError;
  }

  if (onLoad) {
    scriptElement.onload = onLoad;
  }

  document.head.appendChild(scriptElement);
  scriptElement.src = url;
}

function loadWistiaApi() {
  loadScript('//fast.wistia.net/assets/external/E-v1.js');
}

function loadVidyardApi(onLoad, onError) {
  loadScript('//play.vidyard.com/embed/v4.js', onLoad, onError);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-video-player/static-1.2019/js/utils/loadPlayerApi.js
// module id = 291
// module chunks = 0